<template>
    <v-card id="create">
        <v-speed-dial
            v-model="fab"
            bottom
            right
            direction="right"
            transition="slide-y-reverse-transition"
        >
            <v-badge slot="activator" overlap color="orange">
                <v-tooltip right>
                    <v-btn
                        slot="activator"
                        color="primary"
                        v-model="fab"
                        fab
                        hover
                    >
                        <v-icon>cloud_download</v-icon>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <span>Download Reports</span>
                </v-tooltip>
                <span slot="badge">{{ downloadingNum }}/{{ downloadedNum }}</span>
            </v-badge>
            <v-card height="250" class="report-inter">
                <v-card-title @click.stop>
                    <div class="headline primary--text">My Reports
                        <v-btn flat icon small class="closereportlist" @click="fab=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </div>
                    <h3>Downloads</h3>
                    <div v-for="report in newReports" v-bind:key="report.wfi" style="margin: 0.2rem 0;" class="d-flex align-center justify-space-between">
                        <p style="margin: 0;">{{ report.name }}<br />WFI: {{ report.wfi }} - {{ report.timestamp }}</p>
                        <div style="flex: none !important;">
                            <v-btn @click="downloadReport(report.wfi)" flat icon :disabled="report.downloading || report.loading" :loading="report.downloading || report.loading">
                                <v-icon dark>cloud_download</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card-title>
            </v-card>
        </v-speed-dial>
    </v-card>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import * as actions from '@/constants/actions';

export default {
    name: 'report-interstitial',
    mounted() {
        this.$root.$on('report-generating', (e) => {
            this.newReports.unshift({
                name: e.name,
                loading: true,
                downloading: false,
                timestamp: moment().format('LT'),
                wfi: e.wfi,
            });
        });

        this.$root.$on('report-generated', (e) => {
            const report = this.newReports.find(i => i.wfi === e.wfi);
            report.loading = false;
            report.file = e.file;
        });
    },
    data() {
        return {
            fab: false,
            direction: 'left',
            loading: true,
            downloading: false,
            newReports: [],
        };
    },
    computed: {
        downloadingNum() {
            let num = 0;
            this.newReports.forEach(({ loading }) => {
                if (loading) {
                    num += 1;
                }
            });
            return num;
        },
        downloadedNum() {
            let num = 0;
            this.newReports.forEach(({ loading }) => {
                if (!loading) {
                    num += 1;
                }
            });
            return num;
        },
    },
    methods: {
        async downloadReport(downloadWfi) {
            window.gtag('event', 'Report', { action: 'download', label: 'User downloaded report' });
            const report = this.newReports.find(i => i.wfi === downloadWfi);
            report.downloading = true;
            try {
                const { data } = await axios.get(`${this.$cfg.API_URL}/report/${report.file}`, {
                    responseType: 'blob',
                });
                const blob = new Blob([data], { type: 'application/pdf' });
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveBlob(blob, report.file);
                } else {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute('download', report.file);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                report.downloading = false;
            } catch (ex) {
                window.gtag('event', 'Report', { action: 'downloaderror', label: 'There was an error downloading the report' });
                this.$store.dispatch(actions.TRIGGER_TOAST, 'Error downloading report');
            }
        },
    },
};
</script>

<style lang="scss">
#create  {
    button {
        margin: 0;
    }
    bottom: 0;
    left: 28px;
    z-index: 4;
    box-shadow: none;
    background-color: transparent;
    position: absolute;
    .btn--floating {
        position: relative;
    }

    .speed-dial {
        position: relative;
    }

    .badge--overlap .badge__badge {
        width: 30px;
        height: 30px;
    }

    .headline {
        font-size: 18px !important;
        border-bottom: 1px solid #898989;
        font-weight: 500;
        display:flex;
        width:100%;
        justify-content: space-between;
        .closereportlist {
            right:-5px;
        }
    }

    h3 {
        margin-top: 6px;
        font-size: 14px;
        color: #898989;
    }

    .report-inter {
        overflow-y: scroll;

        .card__title {
            display: block !important;
        }
        width: 300px;
        min-width: 300px;
        bottom: 150px;
        left: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReportInterstitial.vue